

(function () {

  const sizeMap = [
    {
      wrist_inch: "4.9 - 5.2”",
      wrist_mm: "125 - 134 mm",
      standart_buckle: "90/50 mm",
      omega_buckle: "70/75 mm"
    },
    {
      wrist_inch: "5.3 – 5.7”",
      wrist_mm: "135 – 145 mm",
      standart_buckle: "95/55 mm",
      omega_buckle: "75/80 mm"
    },
    {
      wrist_inch: "5.8 – 6.0”",
      wrist_mm: "147 – 152 mm",
      standart_buckle: "100/60 mm",
      omega_buckle: "80/85 mm"
    },
    {
      wrist_inch: "6.1 – 6.5”",
      wrist_mm: "154 – 165 mm",
      standart_buckle: "110/65 mm",
      omega_buckle: "85/90 mm"
    },
    {
      wrist_inch: "6.6 – 7.0”",
      wrist_mm: "167 – 177 mm",
      standart_buckle: "120/70 mm",
      omega_buckle: "90/95 mm"
    },
    {
      wrist_inch: "7.1 – 7.5”",
      wrist_mm: "180 – 190 mm",
      standart_buckle: "125/75 mm",
      omega_buckle: "95/100 mm"
    },
    {
      wrist_inch: "7.6 – 8.0”",
      wrist_mm: "193 – 203 mm",
      standart_buckle: "130/80 mm",
      omega_buckle: "100/105 mm"
    },
    {
      wrist_inch: "8.1 – 8.5”",
      wrist_mm: "205 – 215 mm",
      standart_buckle: "135/80 mm",
      omega_buckle: "105/110 mm"
    },
    {
      wrist_inch: "8.6 – 9.0”",
      wrist_mm: "218 – 228 mm",
      standart_buckle: "140/85 mm",
      omega_buckle: "110/115 mm"
    },
    {
      wrist_inch: "9.1 – 9.5”",
      wrist_mm: "231 – 241 mm",
      standart_buckle: "145/90 mm",
      omega_buckle: "115/120 mm"
    },
    {
      wrist_inch: "9.6 – 10.0”",
      wrist_mm: "244 – 254 mm",
      standart_buckle: "150/95 mm",
      omega_buckle: "120/125 mm"
    },
    {
      wrist_inch: "10.0”+",
      wrist_mm: "255 mm+",
      standart_buckle: "155/100 mm",
      omega_buckle: "125/130 mm"
    }
  ];

  const sizeMapLight = [
    {
      wrist_inch: `5.6 - 6.5”`,
      wrist_mm: "152 - 165mm",
      standart_buckle: "110/65mm (Small)",
    },
    {
      wrist_inch: `6.6” - 7.5”`,
      wrist_mm: "167 - 190mm",
      standart_buckle: "120/70mm (Medium)",
    },
    {
      wrist_inch: `7.6” - 8.5”`,
      wrist_mm: "193 - 215mm",
      standart_buckle: "130/80mm (Large)",
    },
    {
      default: true,
      standart_buckle: 'Bespoke recommended'
    }
  ]

  function initCalculator(dom) {
    if (!dom) return

    let els = {
      unitType: null,
      wristInch: null,
      wristMm: null,
      reset: null,
      apply: null,
      result: null,
    }
    let values = {
      unitType: '',
      wristInch: '',
      wristMm: ''
    }

    const type = dom.querySelector('[data-size-calculator-type]')?.dataset.sizeCalculatorType

    function init() {
      els = {
        wristInch: els.wristInch ?? dom.querySelector('[data-size-calculator-wrist-inch]'),
        wristMm: els.wristMm ?? dom.querySelector('[data-size-calculator-wrist-mm]'),
        reset: els.reset ?? dom.querySelectorAll(['[data-size-calculator-reset]']),
        apply: els.apply ?? dom.querySelector(['[data-size-calculator-apply]']),
        result: els.result ?? dom.querySelector('[data-size-calculator-result]')
      }
      if (type === 'light') {
        els.reusltTab = dom.querySelector('[data-size-calculator-light-result]')
        els.fallbackTab = dom.querySelector('[data-size-calculator-light-fallback]')
      }
      els.reset.forEach(el => el.addEventListener('click', resetValues))
      if (!window.sizeCalculator) window.sizeCalculator = {}
      const calculator = dom.querySelector('[data-size-calculator]')
      window.sizeCalculator[calculator.dataset.sizeCalculator] = {
        getValues,
        resetValues,
        calculateSize,
        type
      }
      const openBtn = dom.querySelector('[data-size-calculator-trigger]')
      if (openBtn) {
        window.sizeCalculator[calculator.dataset.sizeCalculator].open = () => {
          const event = new CustomEvent('click', { bubbles: true, })
          openBtn.dispatchEvent(event)
        }
      }

      const closeBtn = dom.querySelector('[data-popup-close]')
      if (closeBtn) {
        const close = () => {
          const event = new CustomEvent('click', { bubbles: true, })
          closeBtn.dispatchEvent(event)
        }
        if (els.apply) {
          els.apply.addEventListener('click', close)
        }
        window.sizeCalculator[calculator.dataset.sizeCalculator].close = close
      }

      if (els.apply) {
        window.sizeCalculator[calculator.dataset.sizeCalculator].apply = els.apply
      }

      const observer = new MutationObserver(() => {
        getValues()
        calculateSize()
      })
      const trigerList = dom.querySelectorAll('[data-size-calculator-trigger]')
      trigerList.forEach(element => {
        observer.observe(element, { attributes: true })
      });
      dom.dataset.init = true
    }

    function getValues() {
      els.unitType = dom.querySelector('.current[data-size-calculator-unit]')
      values = {
        unitType: els.unitType?.dataset?.sizeCalculatorUnit,
        wristInch: els.wristInch?.dataset.optionValueId,
        wristMm: els.wristMm?.dataset.optionValueId
      }
      if (type === 'default') {
        els.buckleType = dom.querySelector('.current[data-size-calculator-buckle]')
        values.buckleType = els.buckleType?.dataset?.sizeCalculatorBuckle
      }
      if (!!els.wristInch && values.wristInch !== els.wristInch.placeholder) {
        const wristEl = els.wristInch?.parentNode?.querySelector('[data-popout-toggle-text]')
        if (wristEl && wristEl.classList.contains('info-text')) {
          wristEl.classList.remove('info-text')
        }
      }
      if (!!els.wristMm && values.wristMm !== els.wristMm.placeholder) {
        const wristEl = els.wristMm?.parentNode?.querySelector('[data-popout-toggle-text]')
        if (!!wristEl && wristEl.classList.contains('info-text')) {
          wristEl.classList.remove('info-text')
        }
      }
      console.log('getValues', values)
      return values
    }

    function resetValues() {
      if (els.wristInch) {
        els.wristInch.dataset.optionValueId = els.wristInch.placeholder
        const wristEl = els.wristInch?.parentNode?.querySelector('[data-popout-toggle-text]')
        if (wristEl) {
          wristEl.innerHTML = els.wristInch.placeholder
          wristEl.classList.add('info-text')
        }
      }
      if (els.wristMm) {
        els.wristMm.dataset.optionValueId = els.wristMm.placeholder
        const wristEl = els.wristMm?.parentNode?.querySelector('[data-popout-toggle-text]')
        if (wristEl) {
          wristEl.innerHTML = els.wristMm.placeholder
          wristEl.classList.add('info-text')
        }
      }
      console.log('resetValues')
    }

    function calculateSize() {
      function calcDefault() {
        let config
        if (values.unitType.trim().toLowerCase() === 'mm') {
          config = sizeMap.find(item => item.wrist_mm.trim().toLowerCase() === values.wristMm?.trim().toLowerCase())
        } else if (values.unitType.trim().toLowerCase() === 'inch') {
          config = sizeMap.find(item => item.wrist_inch.trim().toLowerCase() === values.wristInch?.trim().toLowerCase())
        }
        if (!els.result) return config
        if (!config) {
          if (els.apply) els.apply.disabled = true
          els.result.value = ''
          return els.result.value
        }
        if (els.apply) els.apply.disabled = false
        console.log('calculateSize', config)
        if (values.buckleType.trim().toLowerCase() === 'standart') {
          els.result.value = config.standart_buckle
        } else if (values.buckleType.trim().toLowerCase() === 'omega') {
          els.result.value = config.omega_buckle
        }
        return config
      }
      function calcLight() {
        let config
        if (values.unitType.trim().toLowerCase() === 'mm') {
          config = sizeMapLight.find(item => item.wrist_mm?.trim().toLowerCase() === values.wristMm?.trim().toLowerCase())
        } else if (values.unitType.trim().toLowerCase() === 'inch') {
          config = sizeMapLight.find(item => item.wrist_inch?.trim().toLowerCase() === values.wristInch?.trim().toLowerCase())
        }
        if (!config) {
          config = sizeMapLight.find(item => item.default)
        }
        if (!els.result) return config
        if (els.apply) els.apply.disabled = false
        console.log('calculateSize', config)
        const event = new CustomEvent('click', { bubbles: true, })
        if (values.unitType.trim().toLowerCase() === 'mm' && (!values.wristMm || values.wristMm === els.wristMm.placeholder)) {
          els.result.value = ''
          els.reusltTab.dispatchEvent(event)
        }
        else if (values.unitType.trim().toLowerCase() === 'inch' && (!values.wristInch || values.wristInch === els.wristInch.placeholder)) {
          els.result.value = ''
          els.reusltTab.dispatchEvent(event)
        } else {
          if (config.default) els.fallbackTab.dispatchEvent(event)
          else els.reusltTab.dispatchEvent(event)
          els.result.value = config.standart_buckle
        }
        return config
      }
      if (type === 'default') return calcDefault()
      else return calcLight()
    }
    init()
    getValues()
    resetValues()
  }
  function initializeWithRetry(maxRetries = 3, delay = 500) {
    let attempts = 0;

    function attemptInit() {
      const calculatorList = document.querySelectorAll('.size-calculator__root:not([data-init])');

      if (calculatorList.length > 0) {
        calculatorList.forEach(item => {
          initCalculator(item);
        });
        console.log(`Инициализировано ${calculatorList.length} калькуляторов`);
      }

      attempts++;
      if (attempts < maxRetries && calculatorList.length > 0) {
        setTimeout(attemptInit, delay);
      } else if (calculatorList.length === 0 && attempts > 0) {
        console.log('Все калькуляторы инициализированы');
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attemptInit);
    } else {
      attemptInit();
    }
  }

  initializeWithRetry();
})()

// 4.9 - 5.2”
// 5.3 – 5.7”
// 5.8 – 6.0”
// 6.1 – 6.5”
// 6.6 – 7.0”
// 7.1 – 7.5”
// 7.6 – 8.0”
// 8.1 – 8.5”
// 8.6 – 9.0”
// 9.1 – 9.5”
// 9.6 – 10.0”
// 10.0”+

// 125 - 134 mm
// 135 – 145 mm
// 147 – 152 mm
// 154 – 165 mm
// 167 – 177 mm
// 180 – 190 mm
// 193 – 203 mm
// 205 – 215 mm
// 218 – 228 mm
// 231 – 241 mm
// 244 – 254 mm
// 255 mm+

// 90/50 mm
// 95/55 mm
// 100/60 mm
// 110/65 mm
// 120/70 mm
// 125/75 mm
// 130/80 mm
// 135/80 mm
// 140/85 mm
// 145/90 mm
// 150/95 mm
// 155/100 mm

// 70/75 mm
// 75/80 mm
// 80/85 mm
// 85/90 mm
// 90/95 mm
// 95/100 mm
// 100/105 mm
// 105/110 mm
// 110/115 mm
// 115/120 mm
// 120/125 mm
// 125/130 mm

// LIGHT

// Wrist Size	Recommended Ready-to-Wear size
// Up to 5.5" / 140mm	Bespoke recommended
// 5.6 - 6.5" / 152 - 165mm	110/65mm (Small)
// 6.6" - 7.5" / 167 - 190mm	120/70mm (Medium)
// 7.6" - 8.5" / 193 - 215mm	130/80mm (Large)
// 8.6"+ / 218mm+	Bespoke recommended